module.exports = __webpack_public_path__ + "img/red_exclamation.37e1a902.svg";